import { render, staticRenderFns } from "./OrthographPreview.vue?vue&type=template&id=4b09ab15&lang=pug&"
import script from "./OrthographPreview.vue?vue&type=script&lang=js&"
export * from "./OrthographPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports